import React from 'react';

const AthensBanner = () => {
  return (
    <div className="w-full h-48 overflow-hidden relative" style={{ marginTop: '80px' }}>
      <div 
        className="w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1555993539-1732b0258235?w=2000&h=400&fit=crop&q=80)',
          filter: 'brightness(0.85)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
    </div>
  );
};

export default AthensBanner;
